// extracted by mini-css-extract-plugin
export default {"flag":"Flag_flag__r0asF"};